<template>
    <div class="page">
        <v-container>
        <v-card class="bordered surface-card rounded px-2">
            <v-card-title>Account Settings</v-card-title>
            <v-card-text>
                <v-list color="transparent" class="py-0">
                    <v-list-item @click="passwordDialog = true" v-ripple="false" class="rounded overflow-hidden">
                        <v-list-item-icon class="me-4">
                            <v-icon color="text">mdi-lock-reset</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="text--text">Change Password</v-list-item-title>
                    </v-list-item>

                </v-list>
            </v-card-text>
            
        </v-card>

        <v-dialog transition="slide-y-transition" v-model="passwordDialog" max-width="425" overlay-color="#000" overlay-opacity="0.6">
                <v-card class="px-2 pb-1">
                    <v-card-title>Change Password</v-card-title>
                    <v-card-text class="pt-4">
                        <v-text-field flat filled hide-details label="New Password" :disabled="editing" type="password" :loading="editing" v-model="password"></v-text-field>
                        <v-text-field flat filled hide-details class="mt-5" label="Confirm Password" :disabled="editing" type="password" :loading="editing" v-model="confirmPassword"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn large color="grey darken-1" text @click="passwordDialog = false">cancel</v-btn>
                        <v-btn large class="px-3" color="primary darken-1" :loading="editing" :disabled="editing" text @click="changePassword">confirm</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "Home",
    components: {
        
    },
    data(){
        return {
            loading: false,

            password: '',
            confirmPassword: '',
            passwordDialog: '',
            editing: false,
        }
    },
    computed: {
        
        ...GlobalComputed
    },
    watch: {
        
    },
    methods: {
        
        changePassword(){
            this.editing = true;
            let password = this.password,
                confirm = this.confirmPassword;
            if (password){
                if(password === confirm){
                    this.$store.dispatch('changePassword', {password}).then(()=>{
                        this.showMsg('Password hase been changed successfully', 'success');
                        this.editing = false;
                        this.password = '';
                        this.confirmPassword = '';
                        this.passwordDialog = false;

                    }).catch((error)=>{
                        this.showMsg('Error occurred during preforming your action');
                        this.editing = false;
                        if (error.response && error.response.status === 422){
                            // coming errors from backend
                            let errors = error.response.data.errors;
                            this.showMsg(errors[Object.keys(errors)[0]][0]);

                        }else{
                            this.passwordDialog = false;
                            this.showMsg('Error occurred during creating your account');
                        }
                    })

                }else{
                    this.showMsg('Passwords do not match');
                    this.editing = false;
                }

            }else{
                this.showMsg('Fill required inputs');
                this.editing = false;
                this.passwordDialog = false;
            }
        },
        ...GlobalMethods
    },
    mounted(){
        
    }
};
</script>
